__turbopack_context__.v({
  "section": "card-module__m4sYZa__section",
});
